<mat-toolbar class="md-hue-1" style="height:40px;min-height:40px;max-height:40px">
	<span class="md-title" style="color:white!important">{{stateLicensure?.stateName}}</span>
</mat-toolbar>
<div *ngIf="stateLicensure" class="state-licensure-container flex-col">
	<div class="md-padding">

		<div class="flex-col gap-16">
			<div class="gap-16" [ngClass]="{ 'flex-col': breakpointObserver$ | async, 'flex-row': (breakpointObserver$ | async) === false }">
				<mat-card class="flex-col">
					<mat-card-content class="flex-col space-between">
						<span class="md-title"><strong>Overview</strong></span>
						<div class="flex-row"
							*ngIf="stateLicensure && stateLicensure.licensureProject" style="padding-top:10px">
							<strong class="nova__label frontal"><i class="fa fa-star"
									aria-hidden="true"></i>&nbsp;Licensure Project</strong>
						</div>
						<div class="flex-row" *ngIf="stateLicensure && stateLicensure.compact" style="padding-top:10px">
							<strong class="nova__label frontal"><i class="fa fa-check"
									aria-hidden="true"></i>&nbsp;Compact</strong>
						</div>
						<div class="flex-row" *ngIf="stateLicensure && stateLicensure.nursys" style="padding-top:10px">
							<strong class="nova__label frontal"><i class="fa fa-check"
									aria-hidden="true"></i>&nbsp;Nursys</strong>
						</div>
						<div class="flex-row" *ngIf="stateLicensure&&stateLicensure.tempLicenses"
							style='padding-top:10px'>
							<strong class="nova__label frontal"><i class="fa fa-check" aria-hidden="true"></i>&nbsp;Temp
								Licenses</strong>
						</div>
						<div class="flex-row"
							*ngIf="stateLicensure && stateLicensure.paperlessText && stateLicensure.paperless === 2"
							style="padding-top:10px">
							<strong class="nova__label frontal"><i class="fa fa-check"
									aria-hidden="true"></i>&nbsp;Paperless</strong>
						</div>
						<div class="flex-row"
							*ngIf="stateLicensure&&stateLicensure.paperlessText && stateLicensure.paperless === 3"
							style='padding-top:10px'>
							<strong class="nova__label frontal"><i class="fa fa-check"
									aria-hidden="true"></i>&nbsp;Paperless - Renewals</strong>
						</div>
						<div class="flex-row"
							*ngIf="stateLicensure && stateLicensure.paperlessText&&stateLicensure.paperless === 4"
							style="padding-top:10px">
							<strong class="nova__label frontal"><i class="fa fa-check"
									aria-hidden="true"></i>&nbsp;Paperless - See Notes</strong>
						</div>
						<div class="flex-row" *ngIf="stateLicensure" style='padding-top:10px'>
							<div class="nova__label itemdetails"
								[innerHTML]="bindHtmlLinks(stateLicensure && stateLicensure.paperlessNotes)"></div>
						</div>

						<div>
							<span class="nova__label"
								style="margin-top: 0.7em;display: inline-block;">Attachments:</span>
						</div>

						<mat-list class="condensed-list">
							<mat-list-item *ngFor="let d of stateLicensureAttachedDocs">
								<p>
									<a href="" (click)="downloadFile(d.id, d.fileName)"
										style="font-size:12px; ">{{d.fileName}}</a>
								</p>
							</mat-list-item>
						</mat-list>

						<div style="margin-top: 10px;" *ngIf="stateLicensure.projectNotes">
							<span class="nova__label">Licensure Project Notes:</span>
							<div flex class="nova__label itemdetails" style="padding-left: 16px;"
								*ngIf="stateLicensure.projectNotes">{{stateLicensure.projectNotes}}</div>
						</div>
					</mat-card-content>
				</mat-card>
				<mat-card class="flex-col">
					<mat-card-content class="flex-col space-between">
						<span class="md-title"><strong>Initial</strong></span>
						<div class="flex-row"
							*ngIf="stateLicensure && stateLicensure.initialTimeCategoryText && stateLicensure.initialTimeCategory !== 3"
							style='padding-top:10px'>
							<strong class="nova__label frontal"><i class="fa fa-check"
									aria-hidden="true"></i>&nbsp;{{stateLicensure&&stateLicensure.initialTimeCategoryText}}</strong>
						</div>
						<div class="flex-row" style='padding-top:10px' *ngIf="!isEditMode">
							<div class="flex-30">
								<strong class="nova__label frontal">Initial Time</strong>
							</div>
							<div class="nova__label itemdetails flex-70">
								{{stateLicensure.initialTimeDescription}}</div>
						</div>
						<div class="flex-row" style="padding-top:10px" *ngIf="!isEditMode">
							<div class="flex-30">
								<strong class="nova__label frontal">Initial Cost</strong>
							</div>
							<div flex="70" class="nova__label itemdetails flex-70">${{stateLicensure.initialCost}}</div>
						</div>
						<div class="flex-row" style="padding-top:10px" *ngIf="!isEditMode">
							<div class="flex-30">
								<strong class="nova__label frontal">Cost Breakdown</strong>
							</div>
							<div class="nova__label itemdetails flex-70">
								{{stateLicensure.initialCostBreakdown}}</div>
						</div>
						<div class="flex-row" style="padding-top:10px" *ngIf="!isEditMode">
							<div class="flex-30">
								<strong class="nova__label frontal">Initial Notes</strong>
							</div>
							<div class="nova__label itemdetails flex-70"
								[innerHTML]="bindHtmlLinks(stateLicensure.initialNotes)"></div>
						</div>
					</mat-card-content>
				</mat-card>
				<mat-card class="flex-col" style="flex: 1; overflow: hidden; min-width:250px">
					<mat-card-content class="flex-col space-between">
						<span class="md-title"><strong>Renewal</strong> - For currently active licenses</span>
						<div class="flex-row space-between" style="padding-top:10px" *ngIf="!isEditMode">
							<div class="flex-30">
								<strong class="nova__label frontal">Renewal Time</strong>
							</div>
							<div class="nova__label itemdetails flex-70">{{stateLicensure.renewalTime}}
								{{stateLicensure.renewalTimeText}}</div>
						</div>
						<div class="flex-row space-between" style="padding-top:10px" *ngIf="!isEditMode">
							<div class="flex-30">
								<strong class="nova__label frontal">Renewal Cost</strong>
							</div>
							<div class="nova__label itemdetails flex-70">${{stateLicensure.renewalCost}}</div>
						</div>
						<div class="flex-row space-between" style="padding-top:10px" *ngIf="!isEditMode">
							<div class="flex-30">
								<strong class="nova__label frontal">Cost Breakdown</strong>
							</div>
							<div class="nova__label itemdetails flex-70">{{stateLicensure.renewalBreakdown}}
							</div>
						</div>
						<div class="flex-row space-between" style="padding-top:10px" *ngIf="!isEditMode">
							<div class="flex-30">
								<strong class="nova__label frontal">Renewal Notes</strong>
							</div>
							<div class="nova__label itemdetails flex-70"
								[innerHTML]="bindHtmlLinks(stateLicensure.renewalNotes)"></div>
						</div>
						<div class="flex-row space-between" style="padding-top:10px" *ngIf="!isEditMode">
							<div class="nova__label"
								style="padding:5px 5px 5px 5px; background-color: rgb(207,216,220); font-size: small;">
								<i class="fa fa-info-circle" aria-hidden="true"></i>&nbsp;Reinstatement requires a
								different time and process. Please contact <a
									href="mailto:LicenseSpecialist@ayahealthcare.com">LicenseSpecialist&#64;ayahealthcare.com</a>
								for information
							</div>
						</div>
					</mat-card-content>
				</mat-card>
			</div>

			<mat-card class="flex-col" style="flex: 1; overflow: hidden; min-width:250px">
				<mat-card-content class="flex-col space-between">
					<span class="md-title"><strong>Additional Info</strong></span>
					<div class="flex-row" style='padding-top:20px'>
						<div style="white-space: pre-wrap !important;" class="nova__label"
							[innerHTML]="bindHtmlLinks(stateLicensure.additionalInfo)"></div>
					</div>
				</mat-card-content>
			</mat-card>

		</div>
	</div>
</div>